import { render } from "./BasicButton.vue?vue&type=template&id=4898d1be"
import script from "./BasicButton.vue?vue&type=script&lang=js"
export * from "./BasicButton.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src17432379/src/orprio-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__